// extracted by mini-css-extract-plugin
module.exports = {"player-wrapper":"video_player-wrapper__16fX9","controls-wrapper":"video_controls-wrapper__2lL9X"};